import { Component, OnInit } from '@angular/core';
import { PublicService } from 'src/app/servicios/public/public.service';
import { ServiceService } from 'src/app/servicios/service.service';

@Component({
  selector: 'app-sistema-cogui',
  templateUrl: './sistema-cogui.component.html',
  styleUrls: ['./sistema-cogui.component.css']
})
export class SistemaCoguiComponent implements OnInit {

  public listado: any = [];
  public serve: any;

  constructor(private servi: PublicService, private service: ServiceService) {
    this.listado = this.service.server;
   
  }

  ngOnInit() {
  }

}
